import { useState, useEffect, useRef } from 'react';
import Topo from '../../components/EmpresaConvenio';
import { Form } from 'react-simple-form-control';
import '../../assets/Geogrotesque/geofrotesque.css';
import '../../assets/css/bootstrap-grid.css';
import '../../assets/css/style.css';
import Loading from '../../components/Loading';
import { toast } from 'react-toastify';
import solicitacaoService from '../../services/SolicitacaoService';
import contratoService from '../../services/ContratoService';
import documentoService from '../../services/DocumentoService';
import departamentoService from '../../services/DepartamentoService';
import { NavLink, useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { removeCaracteresEspeciais, emailIsValid, isNullOrEmptyOrWhiteSpaceOrUndefined } from '../../helpers/Helper';
import environment from '../../environment';
import DadosBasicos from './DadosBasicos';
import DadosEmpresaConveniada from './DadosEmpresaConveniada';
import DadosRepresentanteConveniada from './DadosRepresentanteConveniada';
import EnvioContratoProcuracao from './EnvioContratoProcuracao';
import DadosAdministradorConveniada from './DadosAdministradorConveniada';

const Formulario = () => {
    const navigate = useNavigate();
    const recaptchaRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [enableDesconto, setEnableDesconto] = useState(false);
    const [accordionAberto, setAccordionAberto] = useState("dadosBasicos");
    const [checkDesconto, setCheckDesconto] = useState(false);
    const [showRepresentante, setShowRepresentante] = useState({ 2: false, 3: false, 4: false, 5: false });
    const [listFileUpload, setListFileUpload] = useState([]);

    const toggleAccordion = (key) => {
        setAccordionAberto((prev) => (prev === key ? null : key));
    };

    const [form, setForm] = useState({
        lista: { value: [] },
        tipoDocumento: { value: 0 },
        showModalBlackList: { value: false },
        idSolicitacao: { value: 0 },
        tipoEmpresa: {
            value: 0,
            description: "Tipo de empresa",
            validation: {
                output: "tipoEmpresaError",
                validators: [{
                    type: 'required',
                    msg: "Selecione a natureza jurídica."
                }]
            }
        },
        arquivo: { value: 0 },
        tipoArquivo: { value: 0 },
        isArquivoRequired: { value: false },
        tipoConvenio: {
            value: 0,
            description: "Tipo de Convênio",
            validation: {
                output: "tipoConvenioError",
                validators: [{
                    type: 'required',
                    msg: "Selecione o tipo do Convênio."
                }]
            }
        },
        polo: {
            value: '',
            description: "Dados Básicos",
            validation: {
                output: "dadosBasicosError",
                validators: [{
                    type: "custom",
                    params: ["{gestor}", "{polo}"],
                    function: (value, gestor, polo) => {
                        return polo != '' || gestor != '' ? true : false
                    },
                    msg: "É obrigatório informar Consultor ou Polo"
                }]
            }
        },
        idpolo: { value: 0 },
        estadopolo: { value: '' },
        cidadepolo: { value: '' },
        idsegmento: { value: 0 },
        gestor: { value: '' },
        razaoSocial: {
            value: '',
            description: "Razão Social",
            validation: {
                output: "razaoSocialError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [80],
                    msg: "Preencha no máximo 80 caracteres."
                }]
            }
        },
        nomeFantasia: {
            value: '',
            description: "Nome Fantasia",
            validation: {
                output: "nomeFantasiaError",
                validators: [{
                    type: "maxLength",
                    params: [80],
                    msg: "Preencha no máximo 80 caracteres."
                }]
            }
        },
        permiteOfertarCursos: { value: false },
        rua: {
            value: '',
            description: "Rua",
            validation: {
                output: "ruaError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [50],
                    msg: "Preencha no máximo 50 caracteres."
                }]
            }
        },
        numero: {
            value: '',
            description: "Número",
            validation: {
                output: "numeroError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }]
            }
        },
        bairro: {
            value: '',
            description: "Bairro",
            validation: {
                output: "bairroError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [100],
                    msg: "Preencha no máximo 100 caracteres."
                }]
            }
        },
        cep: {
            value: '',
            mask: '99999-999',
            description: "CEP",
            validation: {
                output: "cepError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [14],
                    msg: "Preencha no máximo 14 caracteres."
                }]
            }
        },
        idCidade: { value: 0 },
        cidade: {
            value: '',
            description: "Cidade",
            validation: {
                output: "cidadeError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "minLength",
                    params: [3],
                    msg: "Preencha no mínimo 3 caracteres."
                }, {
                    type: "maxLength",
                    params: [100],
                    msg: "Preencha no máximo 100 caracteres."
                }]
            }
        },
        uf: {
            value: '',
            description: "Estado",
            validation: {
                output: "ufError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "minLength",
                    params: [2],
                    msg: "Preencha no mínimo 2 caracteres."
                }, {
                    type: "maxLength",
                    params: [2],
                    msg: "Preencha no máximo 2 caracteres."
                }]
            }
        },
        complemento: { value: '' },
        idZipCode: { value: 0 },
        idEndereco: { value: 0 },
        ru: { value: 0 },
        idEmpresa: { value: 0 },
        cnpj: {
            value: '',
            description: "CNPJ",
            validation: {
                output: "cnpjError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [18],
                    msg: "Preencha no máximo 18 caracteres."
                }]
            }
        },
        inscricaoEstadual: {
            value: '',
            description: "Inscrição Estadual",
            validation: {
                output: "inscricaoEstadualError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [250],
                    msg: "Preencha no máximo 250 caracteres."
                }]
            }
        },
        site: {
            value: '',
            description: "Site",
            validation: {
                output: "siteError",
                validators: [{
                    type: "maxLength",
                    params: [100],
                    msg: "Preencha no máximo 100 caracteres."
                }]
            }
        },
        emailEmpresa: {
            value: '',
            description: "Email empresa",
            validation: {
                output: "emailEmpresaError",
                validators: [{
                    type: "maxLength",
                    params: [250],
                    msg: "Preencha no máximo 100 caracteres."
                }]
            }
        },
        controleColaboradores: { value: '' },
        numeroColaboradores: { value: '' },
        idPessoaRepresentante: { value: 0 },
        idPessoaDCRepresentante: { value: 0 },
        ruPessoaRepresentante: { value: 0 },
        nomeRepresentante: {
            value: '',
            description: "Nome Representante",
            validation: {
                output: "nomeRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{nomeRepresentante}"],
                    function: (value, adminRepresentante, nomeRepresentante) => {
                        return adminRepresentante > 0 || nomeRepresentante != '' ? true : false
                    },
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [250],
                    msg: "Preencha no máximo 250 caracteres."
                }]
            }
        },
        emailRepresentante: {
            value: '',
            description: "Email Representante",
            validation: {
                output: "emailRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{emailRepresentante}"],
                    function: (value, adminRepresentante, emailRepresentante) => {
                        return adminRepresentante || emailRepresentante != '' ? true : false
                    },
                    msg: 'Campo obrigatório'
                }, {
                    type: 'custom',
                    params: ["{adminRepresentante}", "{emailRepresentante}"],
                    function: (value, adminRepresentante, emailRepresentante) => {
                        return adminRepresentante || emailRepresentante.length < 250 ? true : false
                    },
                    msg: "Preencha no máximo 250 caracteres."
                }, {
                    type: "custom",
                    params: ["{adminRepresentante}", "{emailRepresentante}"],
                    function: (value, adminRepresentante, emailRepresentante) => {
                        return adminRepresentante ? true : emailIsValid(value)
                    },
                    msg: "Email Inválido."
                }]
            }
        },
        cargoRepresentante: {
            value: 0,
            description: "Cargo Representante",
            validation: {
                output: "cargoRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{cargoRepresentante}"],
                    function: (value, adminRepresentante, cargoRepresentante) => {
                        return adminRepresentante || cargoRepresentante > 0 ? true : false
                    },
                    msg: 'Campo obrigatório'
                }]
            }
        },
        idTelefoneRepresentante: { value: 0 },
        telefoneRepresentante: {
            mask: '(99) 99999-9999',
            value: '',
            description: "Telefone Representante",
            validation: {
                output: "telefoneRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{telefoneRepresentante}"],
                    function: (value, adminRepresentante, telefoneRepresentante) => {
                        return adminRepresentante || telefoneRepresentante != '' ? true : false
                    },
                    msg: 'Campo obrigatório'
                }, {
                    type: "custom",
                    function: (value) => {
                        return removeCaracteresEspeciais(value) == 11 ? false : true;
                    },
                    msg: "Preencha no máximo 11 números."
                }]
            }
        },
        tipoTelefoneComercialRepresentante: {
            value: 0,
            description: "",
            validation: {
                output: "tipoTelefoneComercialRepresentanteError",
                validators: [{
                    type: "custom",
                    args: ["telefoneComercialRepresentante"],
                    params: ["{telefoneComercialRepresentante}"],
                    function: (value, telefoneComercialRepresentante) => {
                        return telefoneComercialRepresentante.length > 0 && value == 0 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        idTelefoneComercialRepresentante: { value: 0 },
        telefoneComercialRepresentante: {
            value: '',
            mask: '(99) 9999-9999',
            description: "Telefone Comercial Representante",
            validation: {
                output: "telefoneComercialRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{telefoneComercialRepresentante}"],
                    function: (value, adminRepresentante, telefoneComercialRepresentante) => {
                        return adminRepresentante || telefoneComercialRepresentante != '' ? true : false
                    },
                    msg: 'Campo obrigatório'
                }, {
                    type: "custom",
                    args: ["tipoTelefoneComercialRepresentante"],
                    params: ["{tipoTelefoneComercialRepresentante}"],
                    function: (value, tipoTelefoneComercialRepresentante) => {
                        return tipoTelefoneComercialRepresentante == 0 ? true :
                            tipoTelefoneComercialRepresentante == 1 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 11 ? false :
                                tipoTelefoneComercialRepresentante == 2 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 10 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        cpfRepresentante: {
            value: '',
            mask: '999.999.999-99',
            description: "CPF Representante",
            validation: {
                output: "cpfRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{cpfRepresentante}"],
                    function: (value, adminRepresentante, cpfRepresentante) => {
                        return adminRepresentante || cpfRepresentante != '' ? true : false
                    },
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [15],
                    msg: "Preencha no máximo 14 caracteres."
                }, {
                    type: "custom",
                    function: (value) => {
                        return value = null || value == 0 ? true : value.length > 0 && value.replace("-", "").replace("-", "").length < 11 ? false : true;
                    },
                    msg: "CPF inválido"
                }]
            }
        },
        rgRepresentante: {
            value: '',
            description: "RG Representante",
            validation: {
                output: "rgRepresentanteError",
                validators: [{
                    type: 'custom',
                    params: ["{adminRepresentante}", "{rgRepresentante}"],
                    function: (value, adminRepresentante, rgRepresentante) => {
                        return adminRepresentante || rgRepresentante != '' ? true : false
                    },
                    msg: 'Campo obrigatório'
                }]
            }
        },
        assinaContratoRepresentante: { value: '' },
        idPessoaRepresentante2: { value: 0 },
        idPessoaDCRepresentante2: { value: 0 },
        ruPessoaRepresentante2: { value: 0 },
        nomeRepresentante2: { value: '' },
        emailRepresentante2: { value: '' },
        cargoRepresentante2: { value: 0 },
        idTelefoneRepresentante2: { value: 0 },
        telefoneRepresentante2: { mask: '(99) 99999-9999', value: '' },
        tipoTelefoneComercialRepresentante2: {
            value: 0,
            description: "Tipo Telefone Comercial Representante 2",
            validation: {
                output: "tipoTelefoneComercialRepresentante2",
                validators: [{
                    type: "custom",
                    args: ["telefoneComercialRepresentante2"],
                    params: ["{telefoneComercialRepresentante2}"],
                    function: (value, telefoneComercialRepresentante2) => {
                        return telefoneComercialRepresentante2.length > 0 && value == 0 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        idTelefoneComercialRepresentante2: { value: 0 },
        telefoneComercialRepresentante2: {
            value: '',
            mask: '(99) 9999-9999',
            description: "Telefone Comercial Representante 2",
            validation: {
                output: "telefoneComercialRepresentante2",
                validators: [{
                    type: "custom",
                    args: ["tipoTelefoneComercialRepresentante2"],
                    params: ["{tipoTelefoneComercialRepresentante2}"],
                    function: (value, tipoTelefoneComercialRepresentante2) => {
                        return tipoTelefoneComercialRepresentante2 == 0 ? true :
                            tipoTelefoneComercialRepresentante2 == 1 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 11 ? false :
                                tipoTelefoneComercialRepresentante2 == 2 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 10 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        cpfRepresentante2: { value: '', mask: '999.999.999-99' },
        rgRepresentante2: { value: '' },
        assinaContratoRepresentante2: { value: '' },
        idPessoaRepresentante3: { value: 0 },
        idPessoaDCRepresentante3: { value: 0 },
        ruPessoaRepresentante3: { value: 0 },
        nomeRepresentante3: { value: '' },
        emailRepresentante3: { value: '' },
        cargoRepresentante3: { value: 0 },
        idTelefoneRepresentante3: { value: 0 },
        telefoneRepresentante3: { mask: '(99) 99999-9999', value: '' },
        tipoTelefoneComercialRepresentante3: {
            value: 0,
            description: "Tipo Telefone Comercial Representante 3",
            validation: {
                output: "tipoTelefoneComercialRepresentante3",
                validators: [{
                    type: "custom",
                    args: ["telefoneComercialRepresentante3"],
                    params: ["{telefoneComercialRepresentante3}"],
                    function: (value, telefoneComercialRepresentante3) => {
                        return telefoneComercialRepresentante3.length > 0 && value == 0 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        idTelefoneComercialRepresentante3: { value: 0 },
        telefoneComercialRepresentante3: {
            value: '',
            mask: '(99) 9999-9999',
            description: "Telefone Comercial Representante 3",
            validation: {
                output: "telefoneComercialRepresentante3",
                validators: [{
                    type: "custom",
                    args: ["tipoTelefoneComercialRepresentante3"],
                    params: ["{tipoTelefoneComercialRepresentante3}"],
                    function: (value, tipoTelefoneComercialRepresentante3) => {
                        return tipoTelefoneComercialRepresentante3 == 0 ? true :
                            tipoTelefoneComercialRepresentante3 == 1 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 11 ? false :
                                tipoTelefoneComercialRepresentante3 == 2 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 10 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        cpfRepresentante3: { value: '', mask: '999.999.999-99' },
        rgRepresentante3: { value: '' },
        assinaContratoRepresentante3: { value: '' },
        idPessoaRepresentante4: { value: 0 },
        idPessoaDCRepresentante4: { value: 0 },
        ruPessoaRepresentante4: { value: 0 },
        nomeRepresentante4: { value: '' },
        emailRepresentante4: { value: '' },
        cargoRepresentante4: { value: 0 },
        idTelefoneRepresentante4: { value: 0 },
        telefoneRepresentante4: { mask: '(99) 99999-9999', value: '' },
        tipoTelefoneComercialRepresentante4: {
            value: 0,
            description: "Tipo Telefone Comercial epresentante 4",
            validation: {
                output: "tipoTelefoneComercialRepresentante4",
                validators: [{
                    type: "custom",
                    args: ["telefoneComercialRepresentante4"],
                    params: ["{telefoneComercialRepresentante4}"],
                    function: (value, telefoneComercialRepresentante4) => {
                        return telefoneComercialRepresentante4.length > 0 && value == 0 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        idTelefoneComercialRepresentante4: { value: 0 },
        telefoneComercialRepresentante4: {
            value: '',
            mask: '(99) 9999-9999',
            description: "Telefone Comercial Representante 4",
            validation: {
                output: "telefoneComercialRepresentante4",
                validators: [{
                    type: "custom",
                    args: ["tipoTelefoneComercialRepresentante4"],
                    params: ["{tipoTelefoneComercialRepresentante4}"],
                    function: (value, tipoTelefoneComercialRepresentante4) => {
                        return tipoTelefoneComercialRepresentante4 == 0 ? true :
                            tipoTelefoneComercialRepresentante4 == 1 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 11 ? false :
                                tipoTelefoneComercialRepresentante4 == 2 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 10 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        cpfRepresentante4: { value: '', mask: '999.999.999-99' },
        rgRepresentante4: { value: '' },
        assinaContratoRepresentante4: { value: '' },
        idPessoaRepresentante5: { value: 0 },
        idPessoaDCRepresentante5: { value: 0 },
        ruPessoaRepresentante5: { value: 0 },
        nomeRepresentante5: { value: '' },
        emailRepresentante5: { value: '' },
        cargoRepresentante5: { value: 0 },
        idTelefoneRepresentante5: { value: 0 },
        telefoneRepresentante5: { mask: '(99) 99999-9999', value: '' },
        tipoTelefoneComercialRepresentante5: {
            value: 0,
            description: "Tipo Telefone Comercial Representante 5",
            validation: {
                output: "tipoTelefoneComercialRepresentante5",
                validators: [{
                    type: "custom",
                    args: ["telefoneComercialRepresentante5"],
                    params: ["{telefoneComercialRepresentante5}"],
                    function: (value, telefoneComercialRepresentante5) => {
                        return telefoneComercialRepresentante5.length > 0 && value == 0 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        idTelefoneComercialRepresentante5: { value: 0 },
        telefoneComercialRepresentante5: {
            value: '',
            mask: '(99) 9999-9999',
            description: "Telefone Comercial Representante 5",
            validation: {
                output: "telefoneComercialRepresentante5",
                validators: [{
                    type: "custom",
                    args: ["tipoTelefoneComercialRepresentante5"],
                    params: ["{tipoTelefoneComercialRepresentante5}"],
                    function: (value, tipoTelefoneComercialRepresentante5) => {
                        return tipoTelefoneComercialRepresentante5 == 0 ? true :
                            tipoTelefoneComercialRepresentante5 == 1 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 11 ? false :
                                tipoTelefoneComercialRepresentante5 == 2 && value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length < 10 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        cpfRepresentante5: { value: '', mask: '999.999.999-99' },
        rgRepresentante5: { value: '' },
        assinaContratoRepresentante5: { value: '' },
        idPessoaAdmin: { value: 0 },
        idPessoaDCAdmin: { value: 0 },
        ruPessoaAdmin: { value: 0 },
        nomeAdmin: {
            value: '',
            description: "Nome Administrador",
            validation: {
                output: "nomeAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [250],
                    msg: "Preencha no máximo 250 caracteres."
                }]
            }
        },
        emailAdmin: {
            value: '',
            description: "Email Administrador",
            validation: {
                output: "emailAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [250],
                    msg: "Preencha no máximo 250 caracteres."
                }, {
                    type: "email",
                    msg: "Email Inválido."
                }]
            }
        },
        idTelefoneAdmin: { value: 0 },
        telefoneAdmin: {
            value: '',
            description: "Telefone Administrador",
            mask: '(99) 99999-9999',
            validation: {
                output: "telefoneAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "custom",
                    function: (value) => {
                        return removeCaracteresEspeciais(value) == 11 ? false : true;
                    },
                    msg: "Preencha no máximo 11 números."
                }]
            }
        },
        tipoTelefoneComercialAdmin: {
            value: 0,
            description: "Tipo Telefone Comercial Administrador",
            validation: {
                output: "tipotelefoneComercialAdminError",
                validators: [{
                    type: "custom",
                    args: ["telefoneComercialAdmin"],
                    params: ["{telefoneComercialAdmin}"],
                    function: (value, telefoneComercialAdmin) => {
                        return telefoneComercialAdmin.length > 0 && value == 0 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        idTelefoneComercialAdmin: { value: 0 },
        telefoneComercialAdmin: {
            value: '',
            mask: '(99) 9999-9999',
            description: "Telefone Comercial Administrador",
            validation: {
                output: "telefoneComercialAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "custom",
                    args: ["tipoTelefoneComercialAdmin"],
                    params: ["{tipoTelefoneComercialAdmin}"],
                    function: (value, tipoTelefoneComercialAdmin) => {
                        return tipoTelefoneComercialAdmin == 0 ? true :
                            tipoTelefoneComercialAdmin == 1 && value.length < 15 ? false :
                                tipoTelefoneComercialAdmin == 2 && value.length < 14 ? false : true;
                    },
                    msg: "Verifique preenchimento do campo"
                }]
            }
        },
        cargoAdmin: {
            value: 0,
            description: "Cargo Administrador",
            validation: {
                output: "cargoAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }]
            }
        },
        departamentoAdmin: { value: 0, description: "Departamento Administrador" },
        cpfAdmin: {
            value: '',
            mask: '999.999.999-99',
            description: "CPF Administrador",
            validation: {
                output: "cpfAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }, {
                    type: "maxLength",
                    params: [15],
                    msg: "Preencha no máximo 14 caracteres."
                }, {
                    type: "custom",
                    function: (value) => {
                        return value = null || value == 0 ? true : value.length > 0 && value.replace("-", "").replace("-", "").length < 11 ? false : true;
                    },
                    msg: "CPF inválido"
                }]
            }
        },
        rgAdmin: {
            value: '',
            description: "RG Administrador",
            validation: {
                output: "rgAdminError",
                validators: [{
                    type: 'required',
                    msg: 'Campo obrigatório'
                }]
            }
        },
        adminRepresentante: { value: '' },
        recebeEmailNotaAdm: { value: '' },
        recebeEmailBoletoAdm: { value: '' },
        recebeEmailNota: { value: '' },
        recebeEmailBoleto: { value: '' },
        recebeEmailNotaRepresentante2: { value: '' },
        recebeEmailBoletoRepresentante2: { value: '' },
        recebeEmailNotaRepresentante3: { value: '' },
        recebeEmailBoletoRepresentante3: { value: '' },
        recebeEmailNotaRepresentante4: { value: '' },
        recebeEmailBoletoRepresentante4: { value: '' },
        recebeEmailNotaRepresentante5: { value: '' },
        recebeEmailBoletoRepresentante5: { value: '' },
        representanteEscolha: { value: '' },
        representanteEscolhaCpf: { value: '' },
        assinaContrato: { value: '' },
        idModeloContrato: { value: '' },
        habilitacep: { value: false },
        habilitaDadosPessoais: { value: false },
        habilitaDadosEmpresa: { value: false },
        habilitaDadosAdmin: { value: false },
        habilitaDadosR1: { value: false },
        listModelos: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
        listTiposContrato: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
        listTiposDocumentos: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
        listDepartamento: { value: [] },
        listCargo: { value: [] },
        listEstado: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
        listCidade: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
        listPolo: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
        listResponsaveis: { value: [] },
        listSegmento: { value: [{ codigo: 0, descricao: 'SELECIONE' }] },
    });

    async function _handleResponsavelChangeSet(nomeResponsavel, codigoResponsavel) {
        setForm(prevForm => {
            const novaLista = prevForm.listResponsaveis.value.filter(
                e => e.codigo !== codigoResponsavel
            );

            if (!isNullOrEmptyOrWhiteSpaceOrUndefined(nomeResponsavel)) {
                novaLista.push({
                    descricao: nomeResponsavel,
                    codigo: codigoResponsavel
                });
            }

            return {
                ...prevForm,
                listResponsaveis: {
                    ...prevForm.listResponsaveis,
                    value: novaLista
                }
            };
        });
    }

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setLoading(true);

        // Verificação do ambiente
        if (environment.ambiente !== "PROD") {
            setIsVerified(true);
        }

        // Carrega listas assíncronas
        const [
            listModelos,
            listTiposContrato,
            listTiposDocumentos,
            listDepartamento
        ] = await Promise.all([
            contratoService.OnGetModelos(),
            contratoService.OnGetTipos(),
            documentoService.OnGetTipos(),
            departamentoService.OnGetListaCodigoDescricao()
        ]);

        // Atualiza o estado do formulário
        setForm(prevForm => ({
            ...prevForm,
            tipoEmpresa: { ...prevForm.tipoEmpresa, value: 0 },
            numeroColaboradores: { ...prevForm.numeroColaboradores, value: 0 },
            controleColaboradores: { ...prevForm.controleColaboradores, value: 0 },
            permiteOfertarCursos: { ...prevForm.permiteOfertarCursos, value: 0 },
            adminRepresentante: { ...prevForm.adminRepresentante, value: 0 },

            recebeEmailNotaAdm: { ...prevForm.recebeEmailNotaAdm, value: 0 },
            recebeEmailBoletoAdm: { ...prevForm.recebeEmailBoletoAdm, value: 0 },

            recebeEmailNota: { ...prevForm.recebeEmailNota, value: 0 },
            recebeEmailBoleto: { ...prevForm.recebeEmailBoleto, value: 0 },

            recebeEmailNotaRepresentante2: { ...prevForm.recebeEmailNotaRepresentante2, value: 0 },
            recebeEmailBoletoRepresentante2: { ...prevForm.recebeEmailBoletoRepresentante2, value: 0 },

            recebeEmailNotaRepresentante3: { ...prevForm.recebeEmailNotaRepresentante3, value: 0 },
            recebeEmailBoletoRepresentante3: { ...prevForm.recebeEmailBoletoRepresentante3, value: 0 },

            recebeEmailNotaRepresentante4: { ...prevForm.recebeEmailNotaRepresentante4, value: 0 },
            recebeEmailBoletoRepresentante4: { ...prevForm.recebeEmailBoletoRepresentante4, value: 0 },

            recebeEmailNotaRepresentante5: { ...prevForm.recebeEmailNotaRepresentante5, value: 0 },
            recebeEmailBoletoRepresentante5: { ...prevForm.recebeEmailBoletoRepresentante5, value: 0 },

            complemento: { ...prevForm.complemento, value: "" },
            showModalBlackList: { ...prevForm.showModalBlackList, value: false },
            isArquivoRequired: { ...prevForm.isArquivoRequired, value: false },

            listModelos: { ...prevForm.listModelos, value: listModelos },
            listTiposContrato: { ...prevForm.listTiposContrato, value: listTiposContrato },
            listTiposDocumentos: { ...prevForm.listTiposDocumentos, value: listTiposDocumentos },
            listDepartamento: { ...prevForm.listDepartamento, value: listDepartamento }
        }));

        setLoading(false);
    }

    function verifyCallback(response) {
        if (response)
            setIsVerified(true);
    }

    async function _handleTipoEmpresaChange(event) {
        let _form = { ...form };
        const checked = event.target.checked;
        const valor = event.target.value;

        let tiposDocumentos = await documentoService.OnGetTipos();

        _form.lista.value = [];

        if (checked && valor !== undefined) {
            _form.tipoEmpresa.value = parseInt(valor, 10);

            if (valor === "1") {
                _form.isArquivoRequired.value = false;
                setEnableDesconto(true);
            } else {
                _form.isArquivoRequired.value = true;
                _form.listTiposDocumentos.value = tiposDocumentos;
                _form.tipoConvenio.value = 1;
                setEnableDesconto(true);
            }
        }
        setListFileUpload([]);
        setCheckDesconto(valor !== "1");
        setForm(_form);
    }

    async function _handleConvenioChange(event) {
        let _form = { ...form };
        const checked = event.target.checked;
        const valor = event.target.value;

        let novoTipoConvenio = 0;
        if (checked && valor !== undefined) {
            novoTipoConvenio = parseInt(valor, 10);
        }

        let tiposDocumentos = [];
        if (valor === '2')
            tiposDocumentos = await documentoService.OnGetTipos(novoTipoConvenio);
        else
            tiposDocumentos = await documentoService.OnGetTipos();

        _form.lista.value = [];
        _form.tipoConvenio.value = novoTipoConvenio;
        _form.listTiposDocumentos.value = tiposDocumentos;

        setCheckDesconto(true);
        setForm(_form);
    }

    function buscarDadosForm() {
        return {
            solicitacao: {
                idSolicitacao: null,
                poloId: form.idpolo.value,
                polo: form.polo.value,
                consultor: form.gestor.value.trim(),
                idEmpresa: form.idEmpresa.value,
                idSituacaoSolicitacao: 1,
                idTipoConvenio: form.tipoConvenio.value,
                controlarFuncionarios: form.controleColaboradores.value == '1',
                permiteOfertarCursos: form.permiteOfertarCursos.value == '1',
                dataCriacao: null,
                dataModificacao: null,
                idUsuarioCriador: null,
                idUsuarioModificador: null,
                ativo: true,
                excluido: false
            }
            , empresa: {
                id: form.idEmpresa.value,
                razaoSocial: form.razaoSocial.value.trim(),
                nomeFantasia: (form.nomeFantasia.value == '' || undefined) ? form.razaoSocial.value : form.nomeFantasia.value.trim(),
                cnpj: form.cnpj.value.trim(),
                inscricaoEstadual: form.inscricaoEstadual.value.trim(),
                site: form.site.value.trim(),
                qtdeFuncionarios: (form.numeroColaboradores.value == '' || undefined) ? 0 : Number(form.numeroColaboradores.value.trim()),
                idTipoEmpresa: form.tipoEmpresa.value,
                ru: form.ru.value,
                idEndereco: form.idEndereco.value,
                email: form.emailEmpresa.value != "" || form.emailEmpresa.value != null ? form.emailEmpresa.value.trim() : "",
                idSegmento: form.idsegmento.value
            }
            , endereco: {
                tipoEndereco: 0,
                logradouro: form.rua.value.trim(),
                complemento: form.complemento.value.trim(),
                cep: form.cep.value.trim(),
                //pais: '',
                uf: form.uf.value.trim(),
                cidade: form.cidade.value.trim(),
                bairro: form.bairro.value.trim(),
                numero: form.numero.value.trim(),
                idCidade: form.idCidade.value,
                idEmpresa: form.idEmpresa.value,
                idZipCode: Number(form.idZipCode.value),
                idUf: form.uf.value
            }
            , representante: {
                idPessoaDadosCadastrais: form.idPessoaDCRepresentante.value,
                ru: form.ruPessoaRepresentante.value,
                nome: form.nomeRepresentante.value.trim(),
                nomeSocial: form.nomeRepresentante.value.trim(),
                dataNascimento: null,
                idCargo: form.cargoRepresentante.value,
                idPerfil: 6,
                idDepartamento: 3,
                email: form.emailRepresentante.value.trim(),
                celular: form.telefoneRepresentante.value.trim(),
                comercial: form.telefoneComercialRepresentante.value.trim(),
                cpf: form.cpfRepresentante.value.trim(),
                rg: form.rgRepresentante.value.trim(),
                id: form.idPessoaRepresentante.value,
                recebeEmailNota: form.recebeEmailNota.value == '1',
                recebeEmailBoleto: form.recebeEmailBoleto.value == '1'
            }
            , refepresentante2: {
                idPessoaDadosCadastrais: form.idPessoaDCRepresentante2.value,
                ru: form.ruPessoaRepresentante2.value,
                nome: form.nomeRepresentante2.value.trim(),
                nomeSocial: form.nomeRepresentante2.value.trim(),
                dataNascimento: null,
                idCargo: form.cargoRepresentante.value,
                idPerfil: 6,
                idDepartamento: 3,
                email: form.emailRepresentante2.value.trim(),
                celular: form.telefoneRepresentante2.value.trim(),
                comercial: form.telefoneComercialRepresentante2.value.trim(),
                cpf: form.cpfRepresentante2.value.trim(),
                rg: form.rgRepresentante2.value.trim(),
                id: form.idPessoaRepresentante2.value,
                recebeEmailNota: form.recebeEmailNotaRepresentante2.value == '1',
                recebeEmailBoleto: form.recebeEmailBoletoRepresentante2.value == '1'
            }
            , representante3: {
                idPessoaDadosCadastrais: form.idPessoaDCRepresentante3.value,
                ru: form.ruPessoaRepresentante3.value,
                nome: form.nomeRepresentante3.value.trim(),
                nomeSocial: form.nomeRepresentante3.value.trim(),
                dataNascimento: null,
                idCargo: form.cargoRepresentante.value,
                idPerfil: 6,
                idDepartamento: 3,
                email: form.emailRepresentante3.value.trim(),
                celular: form.telefoneRepresentante3.value.trim(),
                comercial: form.telefoneComercialRepresentante3.value.trim(),
                cpf: form.cpfRepresentante3.value.trim(),
                rg: form.rgRepresentante3.value.trim(),
                id: form.idPessoaRepresentante3.value,
                recebeEmailNota: form.recebeEmailNotaRepresentante3.value == '1',
                recebeEmailBoleto: form.recebeEmailBoletoRepresentante3.value == '1'
            }
            , representante4: {
                idPessoaDadosCadastrais: form.idPessoaDCRepresentante4.value,
                ru: form.ruPessoaRepresentante4.value,
                nome: form.nomeRepresentante4.value.trim(),
                nomeSocial: form.nomeRepresentante4.value.trim(),
                dataNascimento: null,
                idCargo: form.cargoRepresentante.value,
                idPerfil: 6,
                idDepartamento: 3,
                email: form.emailRepresentante4.value.trim(),
                celular: form.telefoneRepresentante4.value.trim(),
                comercial: form.telefoneComercialRepresentante4.value.trim(),
                cpf: form.cpfRepresentante4.value.trim(),
                rg: form.rgRepresentante4.value.trim(),
                id: form.idPessoaRepresentante4.value,
                recebeEmailNota: form.recebeEmailNotaRepresentante4.value == '1',
                recebeEmailBoleto: form.recebeEmailBoletoRepresentante4.value == '1'
            }
            , representante5: {
                idPessoaDadosCadastrais: form.idPessoaDCRepresentante5.value,
                ru: form.ruPessoaRepresentante5.value,
                nome: form.nomeRepresentante5.value.trim(),
                nomeSocial: form.nomeRepresentante5.value.trim(),
                dataNascimento: null,
                idCargo: form.cargoRepresentante.value,
                idPerfil: 6,
                idDepartamento: 3,
                email: form.emailRepresentante5.value.trim(),
                celular: form.telefoneRepresentante5.value.trim(),
                comercial: form.telefoneComercialRepresentante5.value.trim(),
                cpf: form.cpfRepresentante5.value.trim(),
                rg: form.rgRepresentante5.value.trim(),
                id: form.idPessoaRepresentante5.value,
                recebeEmailNota: form.recebeEmailNotaRepresentante5.value == '1',
                recebeEmailBoleto: form.recebeEmailBoletoRepresentante5.value == '1'
            }
            , administrador: {
                idPessoaDadosCadastrais: form.idPessoaDCAdmin.value,
                ru: form.ruPessoaAdmin.value,
                nome: form.nomeAdmin.value.trim(),
                nomeSocial: form.nomeAdmin.value.trim(),
                dataNascimento: null,
                idCargo: form.cargoAdmin.value,
                idPerfil: 2,
                idDepartamento: 3,
                email: form.emailAdmin.value.trim(),
                celular: form.telefoneAdmin.value.trim(),
                comercial: form.telefoneComercialAdmin.value.trim(),
                cpf: form.cpfAdmin.value.trim(),
                rg: form.rgAdmin.value.trim(),
                id: form.idPessoaAdmin.value,
                isRepresentante: form.adminRepresentante.value == '1',
                recebeEmailNota: form.recebeEmailNotaAdm.value == '1',
                recebeEmailBoleto: form.recebeEmailBoletoAdm.value == '1',
                ativo: true,
                excluido: false
            }
        }
    }

    function atualizaSolicitacao(value) {
        setForm((prevForm) => ({
            ...prevForm,
            idSolicitacao: {
                ...prevForm.idSolicitacao,
                value,
            },
        }));
    }

    async function _validarDocumento(values) {
        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(values.cpfRepresentante)) {
            var countRepresentante = 0;
            var listHasRepresentante = values.lista.map(function (e) { return e.representante == values.nomeRepresentante });
            listHasRepresentante.forEach(element => {
                if (element === true) { countRepresentante++ }
            });
            if (countRepresentante < 2)
                return `Envie o CPF e RG do representante: ${values.nomeRepresentante}`;
        }

        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(values.cpfRepresentante2)) {
            var countRepresentante = 0;
            var listHasRepresentante = values.lista.map(function (e) { return e.representante == values.nomeRepresentante2 });
            listHasRepresentante.forEach(element => {
                if (element === true) { countRepresentante++ }
            });
            if (countRepresentante < 2)
                return `Envie o CPF e RG do representante: ${values.nomeRepresentante2}`;
        }

        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(values.cpfRepresentante3)) {
            var countRepresentante = 0;
            var listHasRepresentante = values.lista.map(function (e) { return e.representante == values.nomeRepresentante3 });
            listHasRepresentante.forEach(element => {
                if (element === true) { countRepresentante++ }
            });
            if (countRepresentante < 2)
                return `Envie o CPF e RG do representante: ${values.nomeRepresentante3}`;
        }

        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(values.cpfRepresentante4)) {
            var countRepresentante = 0;
            var listHasRepresentante = values.lista.map(function (e) { return e.representante == values.nomeRepresentante4 });
            listHasRepresentante.forEach(element => {
                if (element === true) { countRepresentante++ }
            });
            if (countRepresentante < 2)
                return `Envie o CPF e RG do representante: ${values.nomeRepresentante4}`;
        }

        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(values.cpfRepresentante5)) {
            var countRepresentante = 0;
            var listHasRepresentante = values.lista.map(function (e) { return e.representante == values.nomeRepresentante5 });
            listHasRepresentante.forEach(element => {
                if (element === true) { countRepresentante++ }
            });
            if (countRepresentante < 2)
                return `Envie o CPF e RG do representante: ${values.nomeRepresentante5}`;
        }

        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(values.cnpj)) {
            var countRepresentante = 0;
            var listHasRepresentante = values.lista.map(function (e) { return e.representante == values.razaoSocial });
            listHasRepresentante.forEach(element => {
                if (element === true) { countRepresentante++ }
            });
            if (countRepresentante < 1)
                return `Envie o contrato social/estatuto da empresa: ${values.razaoSocial}`;
        }
        return '';
    }

    async function onSubmit(values, valid) {
        setLoading(true);
        let _form = { ...form };

        if (isVerified) {
            if (valid[0]) {
                var notConvenioPagamentoHasDoc = true;
                if (_form.tipoConvenio.value == 2) {
                    var validDoc = await _validarDocumento(values);

                    if (!isNullOrEmptyOrWhiteSpaceOrUndefined(validDoc)) {
                        notConvenioPagamentoHasDoc = false;
                        toast.error(validDoc);
                    }
                }

                if (notConvenioPagamentoHasDoc) {
                    let command = buscarDadosForm();
                    const result = await solicitacaoService.insert(command);

                    if (result.success == true) {
                        atualizaSolicitacao(result.data);

                        /*ENVIANDO CONTRATO E DOCUMENTOS*/
                        if (_form.tipoEmpresa.value == 1 && _form.tipoConvenio.value != 2) {
                            let files = listFileUpload;

                            if (files !== undefined) {
                                let contrato = new FormData();
                                for (var index = 0; index < files.length; index++) {
                                    var element = files[index];
                                    contrato.append('File', element);
                                    contrato.append('isContrato', 1);
                                    contrato.append('Tipo', 1);
                                    contrato.append('IdSolicitacao', _form.idSolicitacao.value);
                                    contrato.append('IdPessoa', null);
                                    contrato.append('Descricao', '');
                                    contrato.append('DataInicioVigencia', null);
                                    contrato.append('DataFimVigencia', null);

                                    const returnContrato = await solicitacaoService.OnPostMultUpload(contrato);
                                }
                            }
                        } else if (_form.tipoEmpresa.value == 2 || _form.tipoConvenio.value == 2) {
                            if (_form.lista.value.length > 0) {
                                for (var index = 0; index < _form.lista.value.length; index++) {
                                    let doc = new FormData();
                                    var element = _form.lista.value[index];
                                    doc.append('File', element.arquivo);
                                    doc.append('isContrato', element.idTipoArquivo);
                                    doc.append('Tipo', element.idTipoArquivo == 1 ? 1 : element.idTipo);
                                    doc.append('IdSolicitacao', _form.idSolicitacao.value);
                                    doc.append('IdPessoa', null);
                                    doc.append('Descricao', '');
                                    doc.append('ResponsavelCPF', element.representanteCpf);
                                    doc.append('DataInicioVigencia', null);
                                    doc.append('DataFimVigencia', null);

                                    const returnContrato = await solicitacaoService.OnPostMultUpload(doc);
                                }
                            }
                        }
                        /*ENVIANDO CONTRATO E DOCUMENTOS*/

                        setLoading(false);
                        navigate("/finish");
                    }
                }
                else {
                    toast.warn("Não foi possível salvar o formulário");
                }
            } else {
                toast.error('Verifique o preenchimento dos campos.');
                _form.showModalBlackList.value = true;
                let errors = valid[1].map(erro => `${_form[erro.field].description || erro.field}: ${erro.value}`);
                setErrors(errors);
                setForm(_form);
            }
        } else {
            toast.error("Favor preencher o reCaptcha.")
        }
        setLoading(false);
    }

    return (
        <>
            {loading && Loading}
            <div>
                <div>
                    <Topo></Topo>
                    <div className="uninter-container-convenioempresas">
                        <Form onSubmit={onSubmit} formControl={form} onChangeForm={_form => setForm(_form)}>
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
                                    <NavLink className="uninter-btn-voltar-inicio" id="linkLogin" title="Voltar para tela inicial" to="Login">Início</NavLink>
                                    <h3 className="titleFormulario">FORMULÁRIO PARA FORMALIZAÇÃO DO CONVÊNIO</h3>
                                    <div className="uninter-box-convenioempresas-empresas row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <ul className="uninter-declaro-convenioempresas col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-box-convenioempresas-curso-base">
                                                <span className="midletitle">Tipo de empresa</span>
                                                <li className="form-check">
                                                    <input type="radio" id="empresa-privada" name="tipoEmpresa" value="1" onChange={_handleTipoEmpresaChange} />
                                                    <label className="form-check-label">PRIVADA</label>
                                                    <input type="radio" id="empresa-publica" name="tipoEmpresa" value="2" onChange={_handleTipoEmpresaChange} />
                                                    <label className="form-check-label">PÚBLICA</label>
                                                </li>
                                                <span className="error" id="tipoEmpresaError"></span>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="uninter-box-convenioempresas-empresas row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <ul className="uninter-declaro-convenioempresas col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-box-convenioempresas-curso-base">
                                                <span className="midletitle">Tipo de convênio</span>
                                                <li className="form-check">
                                                    <input type="radio" id="desconto" name="tipoConvenio" value="1" checked={checkDesconto} disabled={!enableDesconto} onChange={_handleConvenioChange} />
                                                    <label className="form-check-label">DESCONTO</label>
                                                </li>
                                                <span className="error" id="tipoConvenioError"></span>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="uninter-passo-geral col-xs-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
                                    <div className="accordion " id="accordionFormulario">
                                        <div className="card uninter-convenioempresas-final uninter-passo uninter-dados_basicos">
                                            <div className="card-header uninter-convenioempresas-header" id="dadosBasicos" onClick={() => toggleAccordion("dadosBasicos")} style={{ cursor: "pointer" }}>
                                                <h3 className="colapseTitle" data-toggle="collapse" data-target="#collapseDadosBasicos" aria-expanded="true" aria-controls="collapseDadosBasicos" id="titleDadosBasicos">Dados básicos
                                                    <i hidden={form.polo.value === "" && form.gestor.value === ""} className="fa fa-check answer-sucess" aria-hidden="true"></i></h3>
                                            </div>
                                            {accordionAberto === "dadosBasicos" && (
                                                <div id="collapseDadosBasicos" className="collapse show colapseDescription" aria-labelledby="dadosBasicos">
                                                    <DadosBasicos form={form} onChangeForm={_form => setForm(_form)} setLoading={setLoading} />
                                                </div>
                                            )}
                                        </div>
                                        <div className="card uninter-convenioempresas-final uninter-passo">
                                            <div className="card-header uninter-convenioempresas-header" id="dadosEmpresaConveniada" onClick={() => toggleAccordion("dadosEmpresaConveniada")} style={{ cursor: "pointer" }}>
                                                <h3 className="colapseTitle" data-toggle="collapse" data-target="#collapseDadosEmpresaConveniada" aria-expanded="false" aria-controls="collapseDadosEmpresaConveniada" id="titleDadosEmpresa">Dados da Empresa Conveniada
                                                    <i hidden={form.cnpj.value === '' || form.inscricaoEstadual.value === '' || form.razaoSocial.value === '' || form.cep.value === ''
                                                        || form.rua.value === '' || form.numero.value === '' || form.bairro.value === '' || form.uf.value === ''} className="fa fa-check answer-sucess" aria-hidden="true"></i></h3>
                                            </div>
                                            {accordionAberto === "dadosEmpresaConveniada" && (
                                                <div id="collapseDadosEmpresaConveniada" className="collapse show colapseDescription" aria-labelledby="dadosEmpresaConveniada"                                                >
                                                    <DadosEmpresaConveniada
                                                        form={form}
                                                        onChangeForm={_form => setForm(_form)}
                                                        setLoading={setLoading}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="card uninter-convenioempresas-final uninter-passo">
                                            <div className="card-header uninter-convenioempresas-header" id="dadosUsuarioAdmin" onClick={() => toggleAccordion("dadosUsuarioAdmin")} style={{ cursor: "pointer" }}>
                                                <h3 className="colapseTitle collapsed" data-toggle="collapse" data-target="#collapseDadosUsuarioAdmin" aria-expanded="false" aria-controls="collapseDadosUsuarioAdmin" id="titleDadosAdmin">
                                                    {form.adminRepresentante.value == 0 ? 'Dados Administrador da Conveniada' : 'Dados Administrador/Representante legal da Conveniada'}
                                                    <i hidden={form.cpfAdmin.value === '' || form.nomeAdmin.value === '' || form.cargoAdmin.value === ''
                                                        || form.emailAdmin.value === '' || form.telefoneAdmin.value === '' || form.telefoneComercialAdmin.value === ''} className="fa fa-check answer-sucess" aria-hidden="true"></i></h3>
                                            </div>
                                            {accordionAberto === "dadosUsuarioAdmin" && (
                                                <div
                                                    id="collapseDadosUsuarioAdmin"
                                                    className="collapse show colapseDescription"
                                                    aria-labelledby="dadosUsuarioAdmin"
                                                >
                                                    <DadosAdministradorConveniada
                                                        form={{ ...form }}
                                                        onChangeForm={_form => setForm(_form)}
                                                        setLoading={setLoading}
                                                        handleResponsavelChangeSet={_handleResponsavelChangeSet}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="card uninter-convenioempresas-final uninter-passo">
                                            <div className="card-header uninter-convenioempresas-header" id="dadosRepresentante" onClick={() => toggleAccordion("dadosDadosRepresentante")} style={{ cursor: "pointer" }}>
                                                <h3 className="colapseTitle" data-toggle="collapse" data-target="#collapseDadosRepresentante" aria-expanded="false" aria-controls="collapseDadosRepresentante" id="titleDadosRepresentante">Dados do Representante legal da Conveniada
                                                    <i hidden={form.cpfRepresentante.value === '' || form.nomeRepresentante.value === '' || form.cargoRepresentante.value === ''
                                                        || form.emailRepresentante.value === '' || form.telefoneRepresentante.value === '' || form.telefoneComercialRepresentante.value === ''} className="fa fa-check answer-sucess" aria-hidden="true"></i></h3>
                                            </div>
                                            {accordionAberto === "dadosDadosRepresentante" && (

                                                <div id="collapseDadosRepresentante" className="collapse show colapseDescription" aria-labelledby="dadosRepresentante" data-parent="#accordionFormulario">
                                                    <DadosRepresentanteConveniada
                                                        loading={loading}
                                                        form={{ ...form }}
                                                        onChangeForm={_form => setForm(_form)}
                                                        setLoading={setLoading}
                                                        showRepresentante={showRepresentante}
                                                        setShowRepresentante={setShowRepresentante}
                                                        handleResponsavelChangeSet={_handleResponsavelChangeSet}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="card uninter-convenioempresas-final uninter-passo">
                                            <div className="card-header uninter-convenioempresas-header" id="uploadArquivos" onClick={() => toggleAccordion("uploadArquivos")} style={{ cursor: "pointer" }}>
                                                <h3 className="colapseTitle" data-toggle="collapse" data-target="#collapseUploadArquivos" aria-expanded="true" aria-controls="collapseUploadArquivos" id="titleUploadArquivos"> {form.tipoEmpresa.value == 0 || form.tipoEmpresa.value == 1 ? 'Envio de Contrato e/ou Procuração' : 'Envio de Arquivos'}
                                                    <span hidden={form.tipoEmpresa.value == 0 || form.tipoEmpresa.value == 1}></span>
                                                    <i hidden={form.lista.value.length === 0} className="fa fa-check answer-sucess" aria-hidden="true"></i></h3>
                                            </div>
                                            {accordionAberto === "uploadArquivos" && (
                                                <div
                                                    id="collapseUploadArquivos"
                                                    className="collapse show colapseDescription"
                                                    aria-labelledby="uploadArquivos"
                                                >
                                                    <EnvioContratoProcuracao
                                                        form={form}
                                                        setForm={setForm}
                                                        loading={loading}
                                                        setLoading={setLoading}
                                                        listFileUpload={listFileUpload}
                                                        setListFileUpload={setListFileUpload}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <br />
                                    <div className="uninter-box-convenioempresas-curso-base indicativoAssinatura">
                                        Esta página é parte integrada e indissociável do CONVÊNIO ENTRE UNINTER EDUCACIONAL S/A e a CONVENIADA, firmado na data da assinatura abaixo mencionada, com o qual a CONVENIADA concorda em sua integralidade.
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <center>
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={environment.siteKey}
                                                onChange={verifyCallback}
                                                hl="pt-BR"
                                            />
                                            <input className="uninter-box-home-convenioempresas-btn-enviar-formulario" type="submit" value="ENVIAR FORMULÁRIO" />
                                            {errors && errors.length > 0 &&
                                                <div className="listErros">
                                                    <div className="uninter-box-convenioempresas-curso-base indicativoAssinatura col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                        <h3>Foram encontrados os seguintes erros</h3>
                                                        {errors.map((item, i) => <div className="listErrosTags" key={i}><i className="fa fa-exclamation-circle"></i>{item}</div>)}
                                                    </div>
                                                </div>
                                            }
                                        </center>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <h3 className="footerDate">Curitiba, {new Date().getDate().toString().padStart(2, '0')} de {["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][new Date().getMonth()]} de {new Date().getFullYear().toString()}</h3>
                                        <span className="pull-left" >
                                            {new Date().getFullYear().toString()} &copy; Empresa Convênio Uninter - Departamento de Tecnologia da Informação
                                        </span>
                                        <p className="copyright pull-right"></p>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Formulario;